<div class="container zci-margin-top c11n-space-stack-10x c11n-space--force">
    <div class="c11n-space-stack-4x">
        <zci-back-link [link]="'/' + backNavigationPath"></zci-back-link>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-xl-6 col-xxl-5 mx-auto">
        <svg
            class="c11n-space-stack-3x"
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M39.0253 25L39.0253 12.946C39.0242 9.77736 37.7646 6.73885 35.5235 4.49866C33.2823 2.25847 30.2432 1 27.0742 1L3.02215 1C2.49167 1 1.98292 1.21071 1.60781 1.58579C1.2327 1.96086 1.02197 2.46957 1.02197 3L1.02197 45C1.02197 45.5304 1.2327 46.0391 1.60781 46.4142C1.98292 46.7893 2.49167 47 3.02215 47L8.97866 47"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M29.0244 1.15796L29.0244 8.99996C29.0244 9.53039 29.2351 10.0391 29.6103 10.4142C29.9854 10.7892 30.4941 11 31.0246 11L38.8653 11"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M22.9799 35C22.9799 36.0609 22.5585 37.0783 21.8083 37.8284C21.0581 38.5786 20.0406 39 18.9796 39L14.9792 39L14.9792 31L18.9796 31C20.0406 31 21.0581 31.4214 21.8083 32.1716C22.5585 32.9217 22.9799 33.9391 22.9799 35Z"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M14.9792 46.998L14.9792 38.998"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M26.9802 31C29.1021 31 31.1371 31.8429 32.6376 33.3431C34.138 34.8434 34.9809 36.8783 34.9809 39C34.9809 41.1217 34.138 43.1566 32.6376 44.6569C31.1371 46.1571 29.1021 47 26.9802 47L26.9802 31Z"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M38.9814 47L38.9814 34C38.9814 33.2044 39.2975 32.4413 39.8602 31.8787C40.4229 31.3161 41.186 31 41.9817 31L46.9821 31"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M38.9814 38.998L43.9819 38.998"
                stroke="#040505"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <h1 class="c11n-text-xl-headline c11n-space-stack-3x" data-cy="page-title">
            {{ grantorContent.edit_remove_user_access.changeAccessWithFormContactInfo.heading }}
        </h1>
        <div class="c11n-space-stack-6x description-text" data-cy="page-description">
            <p>
                {{ text1 }}
                <a
                    c11n-link
                    variant="primary-reinforced"
                    [href]="agentAuthorizationFormUrl"
                    target="_blank"
                    >agent authorization form</a
                >.
            </p>
            <p>{{ text2 }}</p>
            <p>{{ grantorContent.edit_remove_user_access.ttyTddContactInfo }}</p>
        </div>
    </div>
</div>
